import { FieldViewModel, createIndex, fields, getLayerDescription, ICropping, IDataLayer, IDatalayerContext, IField } from "../omnia"
import { IDatalayerMapDependencies } from "../types"

import IGenericFieldLayer = omnia.fields.IGenericFieldLayer
import { omniaResolve } from "@omnia/shared/promises"

export class FieldLayerLoader implements omnia.fields.IGenericFieldLayerLoader {

    static $inject = ["OmniaDatalayersDependencies"]

    constructor(private readonly ctxt: IDatalayerMapDependencies) {

    }

    getLayers(target: IField | ICropping): ng.IPromise<IGenericFieldLayer[]> {


        const fsvc = this.ctxt.fieldSvc

        if (!target.FieldId) {
            return omniaResolve([])
        }

        const targetVm = fields.isCropping(target)
            ? fsvc.findCropping(target.CroppingId)
            : fsvc.findField(target.FieldId)

        if (!targetVm) {
            return omniaResolve([])
        }

        const ids = [target.FieldId]
        const ctxt = this.ctxt.createContext(() => [])
        const svc = this.ctxt.svc

        const filter = getLayerFilter(targetVm)

        return svc.refresh()
            .then(() => svc.getFieldLayers(ids))
            .then(layers =>
                layers
                    .filter(filter)
                    .map(l => createGenericLayer(ctxt, targetVm, l))
            )

    }

}

/**
 * Returns a function which can be used to filter a set of layers to match a specific target
 * As of 210819, following Usersnap 2230, the rules are:
 * - If the target is a field, then any layer associated with this field
 * - If the target is a cropping, then any layer associated with this field, or with a cropping in the same year as that of the target
 */
function getLayerFilter(target: FieldViewModel) {

    const fieldId = target.fieldId

    const croppingIds = target.isCropping()
        ? createIndex(
            target.fieldVm.croppings.filter(c => c.yearId == target.yearId),
            c => c.croppingId
        )
        : {}

    return (l: IDataLayer) => {

        const layerCroppingId = l.CroppingId || 0

        return (l.FieldId == fieldId) && ((layerCroppingId == 0) || croppingIds[layerCroppingId])

    }

}

function createGenericLayer(ctxt: IDatalayerContext, target: FieldViewModel, layer: IDataLayer): IGenericFieldLayer {

    const cropping = layer.CroppingId
        ? target.fieldVm.croppings.find(c => c.croppingId == layer.CroppingId)
        : null

    const name = getLayerDescription(layer, cropping)

    const getInstance = () => {

        const layers = layer.Zones ? [] : [layer]

        return ctxt.loader.loadLayerZones(layers).then(() => ctxt.createMapLayerInstance(layer).asGenericMapLayer())

    }

    return {
        name,
        getInstance
    }


}
